import { id } from 'date-fns/locale';
import { formatInTimeZone } from 'date-fns-tz';

const NLB_TRANSACTION_AT_FORMAT = 'd MMM yy, HH:mm';
const JAKARTA_TZ = 'Asia/Jakarta';

export function formatNlbTransactionAt(
  transactionAt: string | null | undefined
): string {
  if (!transactionAt) {
    return '-';
  }

  return formatInTimeZone(
    new Date(transactionAt),
    JAKARTA_TZ,
    NLB_TRANSACTION_AT_FORMAT,
    { locale: id }
  );
}
